import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "./AuthContext";

const ProtectedRoute = ({ children, allowedRoles, anyPermission = null }) => {
  const { role, status, user, needsOnboarding, sessionReady } = useContext(AuthContext);
  const location = useLocation();
  const token = localStorage.getItem("token");

  if (!sessionReady) {
    return (
      <div
        style={{
          padding: "2rem",
          textAlign: "center",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f8fafc",
        }}
      >
        <div>
          <div style={{ fontSize: "1.5rem", marginBottom: "0.5rem" }}>⏳</div>
          <div style={{ color: "#64748b" }}>Verifying access...</div>
        </div>
      </div>
    );
  }

  if (!token || !role) {
    return <Navigate to="/" replace />;
  }

  // Onboarding is checked first, but only while it is still outstanding.
  // A pending user who has not onboarded yet has not chosen a department —
  // and the department is what decides which managers approve them. Sending
  // them to /pending-approval before that would deadlock: no department, so
  // nobody to ask, and no way back to the picker.
  if (needsOnboarding && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }

  const userStatus = status || user?.status;
  if (userStatus && userStatus !== "approved" && !needsOnboarding) {
    return <Navigate to="/pending-approval" replace />;
  }

  const normalizedRole = role.toString().toLowerCase();
  const normalizedAllowed = (allowedRoles || []).map((r) => r.toString().toLowerCase());
  const permList = Array.isArray(user?.permissions) ? user.permissions : [];
  const extra = Array.isArray(anyPermission) ? anyPermission : anyPermission ? [anyPermission] : [];
  const hasExtra = extra.length > 0 && extra.some((p) => permList.includes(p));
  const roleOk = normalizedAllowed.length === 0 || normalizedAllowed.includes(normalizedRole);

  if (!roleOk && !hasExtra) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
